import { IHandoverSchema } from "../@types/handover";
import { PcseVoucherSupplement, PcseVoucherType } from "../@types/pcse";
import axios from "../utils/axios";

/** `POST /patient/:patientId/handover/:id/direct-till` */
export interface DirectTillRequest {
  /** Gross amount charged, before any NHS voucher. */
  amount: number;
  nhsVoucher?: {
    type: PcseVoucherType;
    supplements?: PcseVoucherSupplement[];
    lensesAffected?: number;
  };
  description?: string;
  suppliedDate?: string;
}

export interface DirectTillResult {
  handoverId: number;
  patientId: string;
  dispenseId: number;
  tillId?: number;
  grossAmount: number;
  nhsVoucherValue: number;
  /** What the till is asking the patient for. */
  netAmount: number;
  voucherBand?: string;
  voucherValuedOn?: string;
  reusedExistingDispense: boolean;
}

export class HandoverService {
  getAllHandoverByClinicalRecordId(patientId: any, handoverId?: number) {
    const query = typeof handoverId === 'number' ? `?handoverId=${handoverId}` : '';
    return axios.get(`/patient/${patientId}/handover${query}`);
  }
  createHandover(patientId: any, data: IHandoverSchema) {
    return axios.post(`/patient/${patientId}/handover`, data);
  }
  updateHandover(patientId: any, id: number, data: IHandoverSchema) {
    return axios.patch(`/patient/${patientId}/handover/${id}`, data);
  }

  /**
   * Raise a till line straight off the Handover screen.
   *
   * `amount` is the GROSS charge. Any NHS voucher is valued server-side and
   * deducted, so the till only ever asks the patient for their own share — the
   * NHS side is recovered separately through a GOS3 claim.
   */
  createDirectTill(
    patientId: string,
    handoverId: number,
    data: DirectTillRequest
  ) {
    return axios.post<DirectTillResult>(
      `/patient/${patientId}/handover/${handoverId}/direct-till`,
      data
    );
  }
}
